// extracted by mini-css-extract-plugin
export default {"inputAuthKey":"UjFwOK","submitButton":"j_cFkz","formContainer":"TVRaUF","logo":"M11iZt","logoContainer":"yh3DzT"};